<template>
  <div class="about-page">
    <div class="header-wrap">
      <div class="app-flex-mid-center">
        <img src="../../../assets/about-2.png" class="about-img" />
      </div>
      <base-text title="一流的服务、卓越的产品、精湛的技术" class="desc-text"></base-text>
    </div>
    <div class="main">
      <base-title title="公司概况" richTitle="Company profile">section article</base-title>
      <div class="desc-cont">
        <div class="article-section">四川宏博腾科技有限公司系一家民营高科技企业，专业从事工业设备、工业自控系统研发、工业视觉系统研发、教育信息系统的销售和售后服务。</div>
        <div class="article-section">公司拥有一批具备丰富实践经验和较高业务素质的骨干人员，公司产品已广泛应用于军工、电力、电子、锂电、汽车制造、化工、水泥、钢铁冶炼、大专院校、酿酒等各个领域，得到了业内人士的一致认可和好评，取得了良好的社会效益。</div>
        <div class="article-section">
          公司依靠领先成熟的销售网络，创新高效的服务，良好的信誉和人性的企业文化，积极整合外部和内部资源，秉承“为客户缔造精品产品和提供优质服务，为员工创造财富，为社会担当责任”的公司使命、“诚信、专注、专业”的经营理念，注重与客户的通力合作，在公平、互利的原则下，为客户提供专业的产品解决方案！公司全体同仁有信心和决心让“用心服务，真诚合作”的公司理念深入每个客户。
        </div>
      </div>

      <base-title title="服务理念" richTitle="idea">section article</base-title>
      <div class="desc-cont">
        <div class="article-section">我司自成立以来，始终以“一流的服务、卓越的产品、精湛的技术”为宗旨，坚持以市场需求为导向，始终把“扎根行业、精益求精”作为发展的理念。</div>
        <div class="article-section">
          为了维护客户切身权益，我们还采取了许多切实可行的措施以保证售后服务的方便快捷。公司设有售后服务专线电话，接到客户售后电话，10分钟内响应客户需求，成立由专人负责制协助客户排除故障，售后服务工程师每月定期实地走访客户，检测设备运行情况，协助客户做好日常维护、保养，并随时提供服务咨询，解答客户疑问，免费培训操作维修人员。
        </div>
      </div>
    </div>

    <base-foot></base-foot>
  </div>
</template>

<script>
import BaseText from '../components/BaseText.vue'
import BaseTitle from '../components/BaseTitle.vue'
import BaseFoot from '../components/BaseFoot.vue'

export default {
  name: 'AboutPage',
  components: {
    BaseText,
    BaseTitle,
    BaseFoot
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  width: 100%;
  .header-wrap {
    width: inherit;
    height: 925px;
    overflow: hidden;
    background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 100%);
    .about-img {
      width: auto;
      height: 664px;
    }
    .desc-text {
      margin-top: 54px;
    }
  }
  .main {
    padding: 0px 260px 200px;
    .desc-cont {
      margin-top: 40px;
      .article-section {
        color: #4c4c4c;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 47px;
        text-indent: 48px;
        &:not(:last-child) {
          margin-bottom: 70px;
        }
      }
    }
  }
}
</style>
